const TAM_FILTER_LIST = [
	"Script error. @",
	"Can't find variable",
	'Uncaught SecurityError: Blocked a frame with origin "https://wenwen.sogou.com" from accessing a cross-origin frame. @',
	'Uncaught SecurityError: Blocked a frame with origin "https://zhinan.sogou.com" from accessing a cross-origin frame',
	'Uncaught SecurityError: Blocked a frame with origin "https://baike.sogou.com" from accessing a cross-origin frame',
	'SecurityError: Blocked a frame with origin "https://wenwen.sogou.com" from accessing a cross-origin frame. Protocols, domains, and ports must match. @',
	"Uncaught InvalidStateError: An attempt was made to use an object that is not, or is no longer, usable. @ (https://hhy.sogoucdn.com/aegis-sdk/latest/aegis.min.js:10:68)",
	"Uncaught QuotaExceededError: Failed to set a named property on 'Storage': Setting the value of '__bizResourceFirstDownloadTime' exceeded the quota. @ (https://theta.sogoucdn.com/ws/comp/js/biz_main_resource.9faef24d.js:4:47448)",
	"Uncaught SyntaxError: Unexpected token =>",
	"Uncaught SyntaxError: Unexpected token )",
	"Uncaught SyntaxError: missing ) after argument list ",
	"Uncaught SyntaxError: Unexpected token ILLEGAL ",
	"Uncaught SyntaxError: Identifier 'kImgMinWidth' has already been declared",
	"Uncaught SyntaxError: Unexpected token o",
	"Uncaught SyntaxError: Unexpected token u in JSON at position 0",
	"Uncaught SyntaxError: Unexpected string @",
	"Uncaught SyntaxError: Unexpected token < @",
	"Uncaught SyntaxError: Unexpected token ? @ (:1:",
	"Uncaught SyntaxError: Unexpected token 'if' @",
	"SyntaxError: JSON Parse error: Unexpected identifier 'object'",
	"SyntaxError: Unexpected identifier 'logo_300x300'",
	"Uncaught RangeError: Maximum call stack size exceeded @",
	"Uncaught ReferenceError: c35 is not defined",
	"Uncaught ReferenceError: vivo_checkMediaPausedReason is not defined ",
	"Uncaught ReferenceError: processRandomSelector is not defined",
	"Uncaught ReferenceError: __tv_keydown is not defined @ (:1:1)",
	"Uncaught ReferenceError: hit_test is not defined",
	"Uncaught ReferenceError: insertStyle is not defined",
	"Uncaught ReferenceError: check_user_script is not defined",
	"Uncaught ReferenceError: native_call_sniff_media_res is not defined",
	"Uncaught ReferenceError: webplusJsCallback is not defined",
	"Uncaught ReferenceError: dispatchJSEvent is not defined",
	"Uncaught ReferenceError: execute_auto_fill is not defined",
	"Uncaught ReferenceError: x5onSkinSwitch is not defined",
	"Uncaught ReferenceError: ucapi is not defined @",
	"Uncaught ReferenceError: setflashfocus is not defined @ ",
	"Uncaught ReferenceError: Promise is not defined @ ",
	"Uncaught ReferenceError: nav_call_update_item_status is not defined @",
	"Uncaught ReferenceError: nav_call_text_auto_fit is not defined @",
	"Uncaught ReferenceError: onNightModeChanged is not defined",
	"Uncaught ReferenceError: execute_rules is not defined @ (:1:14)",
	"Uncaught ReferenceError: privateSpecialRepair is not defined @",
	"Uncaught ReferenceError: ServerLocationCb",
	"Uncaught ReferenceError: onResume is not defined @ ",
	"Uncaught ReferenceError: setShareUrlParams is not defined @",
	"Uncaught ReferenceError: Set is not defined @",
	"Uncaught ReferenceError: ReactDOM is not defined @ ",
	"Uncaught ReferenceError: changeThemeType is not defined @ (:1:12)",
	"Uncaught TypeError: t is not a function @ (https://hhy.sogoucdn.com",
	"Uncaught TypeError: Cannot read property 'split' of undefined @ (https://baike.sogou.com",
	"Uncaught TypeError: Cannot read property 'close_cache_key' of undefined",
	"Uncaught TypeError: Cannot read property 'playState' of undefined",
	"Uncaught TypeError: Cannot read property 'createObjectStore' of undefined",
	"Uncaught TypeError: Cannot read property 'init' of undefined @ (:0:0)",
	"Uncaught TypeError: Failed to execute 'scrollTo' on 'Window'",
	"Uncaught TypeError: Cannot set property 'volume' of undefined",
	"Uncaught TypeError: Cannot redefine property: onmessage",
	"Uncaught TypeError: myVideo.pause is not a function",
	"Uncaught TypeError: vivoNewsDetailPage.getNewsReadStatus4Vivo is not a function",
	"Uncaught TypeError: Cannot read property 'init' of undefined @ (:0:0)",
	"Uncaught TypeError: Cannot read properties of null (reading 'style') @ (https://hhy.sogoucdn.com/404/latest/404.js",
	"TypeError: Argument 1 ('element') to Window.getComputedStyle must be an instance of Element @ ",
	"Uncaught TypeError: Cannot read property 'createObjectStore' of undefined @",
	"Uncaught TypeError: Cannot read property 'getAttribute' of null @ (https://baike.sogou.com",
	"Uncaught TypeError: Cannot read property 'appendChild' of null @ (https://baike.sogou.com",
	"Uncaught TypeError: Cannot read property 'removeChild' of null @ (https://baike.sogou.com",
	"Uncaught TypeError: Cannot read property 'triggerEvent' of undefined @ (https://baike.sogou.com",
	"Uncaught TypeError: Cannot read property 'getAttribute' of null @ (:668:17)",
	"Uncaught TypeError: Cannot read property 'removeChild' of null @ (:1:5978)",
	"Uncaught TypeError: Cannot read property 'appendChild' of null @ (:1:5924)",
	"Uncaught TypeError: Cannot read property 'length' of undefined @ (:127:17)",
	"Uncaught TypeError: undefined is not a function @ (:1:69)",
	"Uncaught TypeError: b.apply is not a function @ (https://hhy.sogoucdn.com/js/lib/react",
	"Uncaught TypeError: Cannot read property 'click' of null @ (:1:109)",
	"Uncaught TypeError: Cannot read property 'remove' of undefined @ (https://wenwen.sogou.com",
	"Uncaught TypeError: Cannot read property 'getBoundingClientRect' of undefined @ (https://baike.sogou.com",
	"Uncaught TypeError: Cannot read properties of null (reading 'removeChild') @",
	"Uncaught TypeError: Cannot read properties of null (reading 'appendChild') @",
	"TypeError: undefined is not an object (evaluating 't.uv')",
	"TypeError: undefined is not an object (evaluating 'g.$UCADBlock.style_node.sheet')",
	"TypeError: null is not an object (evaluating 'window.mttLongPressVar.tagName')",
	"Uncaught TypeError: mbrowser.",
	"Uncaught TypeError: document.querySelectorAll(...).forEach is not a function",
	"Uncaught Error: Minified React error #227;",
	"Error.message: hit_test is not defined",
	"null is not an object (evaluating 'element.parentElement.tagName') ",
	"The string did not match the expected pattern",
	"Cannot set properties of undefined (setting 'volume')",
	"Cannot read properties of undefined (reading 'contentWindow')",
	"hit_swipe_element is not defined",
	"Cannot read property 'contentWindow' of undefined",
	"Failed to execute 'scrollTo' on 'Window'",
	"window.bannerNight is not a function",
	"sniff_video is not defined",
	"Cannot redefine property: platform",
	"Unexpected end of input",
	"window.sogouMobileExplorer.triggerEvent",
	"window.ucbrowser.smWeather",
	"Cannot read property 'highlightRender' of undefined",
	"UCShellJava",
	"SVGSVGElement",
	"qb_Passive",
	"getUserConnStatus",
	'className.indexOf("MTTATTRIBUTE_Done"',
	'SyntaxError: JSON Parse error: Unexpected identifier "object" @ ',
	"Error.message: Cannot read property 'getAttribute' of null \n  Error.stack: TypeError: Cannot read property 'getAttribute' of null\n    at __addbyspecial",
	"语法错误 @",
	"Syntax error @",
	"evaluating",
	"of undefined @ (:1:",
	"not defined @ (:1:",
	"of null @ (:1:",
	"setThemeLayout",
]; //补充过滤规则

const ANTI_SPIDER_KEYWORDS = [
	"webdriver",
	"__driver_evaluate",
	"__webdriver_evaluate",
	" __selenium_evaluate",
	"__fxdriver_evaluate",
	"__driver_unwrapped",
	"__webdriver_unwrapped",
	"__selenium_unwrapped",
	"__fxdriver_unwrapped",
	"_Selenium_IDE_Recorder",
	"_selenium",
	"calledSelenium",
	"_WEBDRIVER_ELEM_CACHE",
	"ChromeDriverw",
	"driver-evaluate",
	"webdriver-evaluate",
	"selenium-evaluate",
	"webdriverCommand",
	"webdriver-evaluate-response",
	"__webdriverFunc",
	"__webdriver_script_fn",
	"__$webdriverAsyncExecutor",
	"__lastWatirAlert",
	"__lastWatirConfirm",
	"__lastWatirPrompt",
	"$chrome_asyncScriptInfo",
	"$cdc_asdjflasutopfhvcZLmcfl_",
	"_phantom",
	"_phantomas",
];

let urlRulesObj;
try {
	//$CMSCONFIG为变量占位符，编译后进行文本替换，此处加入eslint-disable-next-line消除警告
	// eslint-disable-next-line no-undef
	urlRulesObj = $CMSCONFIG;
} catch (error) {}

function detectAuto() {
	const _hhyKey = getKey();
	for (let i = 0; i < ANTI_SPIDER_KEYWORDS.length; i++) {
		const keyword = fromCode(ANTI_SPIDER_KEYWORDS[i], _hhyKey);
		if (
			!!window[keyword] ||
			!!(
				window.document &&
				window.document.documentElement &&
				window.document.documentElement.getAttribute &&
				window.document.documentElement.getAttribute(keyword)
			) ||
			!!(navigator && navigator[keyword])
		) {
			return true;
		}
	}
	return false;
}

function getKey() {
	const a = ["hhy", "search", "sogu"];
	let key = "";

	for (let index = 0; index < 10; index++) {
		key += index;
	}

	a[1] = "trace";
	a[0] = "hy";

	key += a[0];
	key += a[2];
	key += a[1];

	key = key.toUpperCase().split("").reverse().join("");

	return key;
}

function fromCode(str, key) {
	const l = key.length;
	let b,
		b1,
		b2,
		b3,
		d = 0,
		s;
	s = new Array(Math.floor(str.length / 3));
	b = s.length;
	for (let i = 0; i < b; i++) {
		b1 = key.indexOf(str.charAt(d));
		d++;
		b2 = key.indexOf(str.charAt(d));
		d++;
		b3 = key.indexOf(str.charAt(d));
		d++;
		s[i] = b1 * l * l + b2 * l + b3;
	}
	b = eval("String.fromCharCode(" + s + ")");
	return b;
}
function isPC(ua) {
	if (!ua) return true;

	const isWindowsPhone = /(?:Windows Phone)/i.test(ua),
		isSymbian = /(?:SymbianOS)/i.test(ua) || isWindowsPhone,
		isAndroid = /(?:Android)/i.test(ua),
		isFireFox = /(?:Firefox)/i.test(ua),
		isTablet =
			/(?:iPad|PlayBook)/i.test(ua) ||
			(isAndroid && !/(?:Mobile)/i.test(ua)) ||
			(isFireFox && /(?:Tablet)/i.test(ua)),
		isPhone = /(?:iPhone)/i.test(ua) && !isTablet,
		isPcMiniProgram = /(?:MiniProgramEnv\/(Mac|Windows))/i.test(ua),
		isPc = !isPhone && !isAndroid && !isSymbian && !isPcMiniProgram;
	return isPc;
}
function gatherUrl() {
	const regexList = urlRulesObj?.urlRules;
	const _url = location.href;
	if (_url.length && regexList) {
		for (let i = 0; i < regexList.length; i++) {
			const regexItem = regexList[i];
			const reg = new RegExp(regexItem.regexp_rule);
			if (reg && reg.test && reg.test(_url)) {
				return regexItem.regexp_displayname;
			}
		}

		return _url;
	} else {
		return _url;
	}
}
try {
	const ua = window.navigator.userAgent;
	const isPc = isPC(ua);
	const tamConfig = {
		baikePc: {
			id: "pwvWKAmtUFVZjXTPYy",
		},
		baikeWap: {
			id: "pwvWKAmtemEGtjuPcu",
		},
		wenwenPc: {
			id: "pwvWKAmtitgtyyvXhf",
		},
		wenwenWap: {
			id: "pwvWKAmtqLCzlsoBql",
		},
		zhinanPc: {
			id: "pwvWKAmtwfMaqZslHR",
		},
		zhinanWap: {
			id: "pwvWKAmtHskCMHbpaE",
		},
	};

	const hostPrefix = location.hostname.replace(".sogou.com", "");
	const appPrefixArr = hostPrefix.split(".");
	const appPrefix = appPrefixArr[appPrefixArr.length - 1];
	const app = appPrefix + (isPc ? "Pc" : "Wap");

	if (!window._gtag) {
		window._gtag = {};
	}
	let env = "production";
	switch (window._gtag.env) {
		case "production":
			env = "production";
			break;
		case "preview":
			env = "pre";
			break;
		case "dev":
			env = "local";
			break;
		case "test":
			env = "test";
			break;
		default:
			env = "others";
			break;
	}

	window._gtag.aegis = new Aegis({
		id: tamConfig[app].id,
		env: env,
		reportApiSpeed: true,
		reportAssetSpeed: true,
		pagePerformance: {
			urlHandler() {
				const GATHERURL = gatherUrl();
				if (GATHERURL) return GATHERURL;
			},
		},
		beforeRequest: function (data) {
			if (detectAuto() || env === "local") {
				//命中爬虫或环境为开发环境直接屏蔽，不进行上报!
				return false;
			}
			//入参data的数据结构：{logs: {…}, logType: "log"}
			if (data.logType === "log") {
				let notIn = true; //是否命中过滤特征
				for (let i = 0; i < TAM_FILTER_LIST.length; i++) {
					if (data.logs.msg.indexOf(TAM_FILTER_LIST[i]) > -1) {
						notIn = false;
					}
				}
				return notIn;
			}
		},
	});
} catch (e) {}
